import { ThemeColors } from '../../../'

export interface ExtensionPromptColors {
  Background: ThemeColors
  TitleFontColor: ThemeColors
  ScrollingList: {
    Item: {
      TitleFontColor: ThemeColors
      SubtitleFontColor: ThemeColors
    }
  }
}

export const extensionPromptColors: ExtensionPromptColors = {
  Background: {
    default: 'bg.default',
  },
  TitleFontColor: {
    default: 'fg.subtle',
  },
  ScrollingList: {
    Item: {
      TitleFontColor: {
        default: 'fg.subtle',
      },
      SubtitleFontColor: {
        default: 'fg.muted',
      },
    },
  },
}
